const apiUrl = "http://localhost:8883";
const popUpDisplayTime = 5000;
const selfcareLink = "http://example.com";
const confirmButtonId = "confirmButtonId";
const basename = ""

const config = {
    apiUrl,
    popUpDisplayTime,
    selfcareLink,
    confirmButtonId,
    basename
}

export default config
